import dayjs from 'dayjs';
import { TFunction } from 'i18next';
import { UpdateSubmissionPayloadDto } from 'libs/pinnacle-sdk';
import { getLocalDateForMidnightUTC } from 'utils';
import * as yup from 'yup';

export const getValidationSchema = (t: TFunction) =>
  yup.object().shape({
    assignedHandlerId: yup
      .string()
      .required(t('validation.required', { field: t('general.underwriter') })),

    namedUnderwriterId: yup
      .string()
      .required(
        t('validation.required', { field: t('submission.namedUnderwriter') })
      ),

    inceptionDate: yup
      .date()
      .required(
        t('validation.required', { field: t('submission.inceptionDate') })
      ),

    expiryDate: yup
      .date()
      .required(t('validation.required', { field: t('submission.expiryDate') }))
      .test(
        'is-after-inception',
        t('validation.dateAfterInception', {
          field: t('submission.expiryDate'),
          date: t('submission.inceptionDate'),
        }),
        function (value) {
          const inceptionDate = this.parent.inceptionDate;
          if (!inceptionDate) return true;
          return dayjs(value).isAfter(
            getLocalDateForMidnightUTC(inceptionDate)
          );
        }
      ),

    principalOccupation: yup.string().required(
      t('validation.required', {
        field: t('submission.principalOccupation'),
      })
    ),

    subClass: yup.string().required(
      t('validation.required', {
        field: t('submission.subClass'),
      })
    ),

    originalCurrency: yup
      .string()
      .required(t('validation.required', { field: t('general.currency') })),

    mainRegionAndRiskTerritory: yup.string().required(
      t('validation.required', {
        field: t('submission.mainRegionAndRiskTerritory'),
      })
    ),

    keyRiskLocation: yup
      .string()
      .required(
        t('validation.required', { field: t('submission.keyRiskLocation') })
      ),
  });

export const fields: (keyof UpdateSubmissionPayloadDto)[] = [
  'assignedHandlerId',
  'namedUnderwriterId',
  'inceptionDate',
  'expiryDate',
  'principalOccupation',
  'originalCurrency',
  'mainRegionAndRiskTerritory',
  'keyRiskLocation',
  'subClass',
];
